(() => {
  const areas = {
    general: { label: 'General', desktop: [445, 17], mobile: [201, 16], desktopRow: 17, mobileRow: 16 },
    'hair-scalp': { label: 'Hair & Scalp', desktop: [152.5, 70.5], mobile: [95.4664, 49.1183], desktopRow: 70, mobileRow: 49 },
    face: { label: 'Face', desktop: [152.5, 121.5], mobile: [95.4664, 81.046], desktopRow: 121, mobileRow: 81 },
    'neck-thyroid': { label: 'Neck & Thyroid', desktop: [152.5, 196.5], mobile: [95.4664, 127.998], desktopRow: 196, mobileRow: 128 },
    breast: { label: 'Breast', desktop: [152.5, 299.5], mobile: [95.4664, 192.479], desktopRow: 299, mobileRow: 192 },
    liver: { label: 'Liver', desktop: [118.5, 364.5], mobile: [117.195, 233.199], desktopRow: 364, mobileRow: 233 },
    back: { label: 'Back', desktop: [207.5, 402.5], mobile: [129.898, 261.959], desktopRow: 402, mobileRow: 262 },
    'pelvis-cycle': { label: 'Pelvis / Cycle', desktop: [153.5, 499.5], mobile: [96.0924, 317.685], desktopRow: 499, mobileRow: 318 },
    cellulite: { label: 'Cellulite, Scars, & Stretchmarks', desktop: [229.5, 558.5], mobile: [143.671, 354.62], desktopRow: 558, mobileRow: 355 },
    knee: { label: 'Knee', desktop: [188.5, 729.5], mobile: [118.004, 461.671], desktopRow: 729, mobileRow: 462 },
    feet: { label: 'Feet', desktop: [188.5, 980.5], mobile: [118.004, 618.804], desktopRow: 980, mobileRow: 619 }
  };
  const areaIds = Object.keys(areas);
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const init = (root) => {
    if (root.dataset.initialized) return;
    const wrap = root.querySelector('[data-diagram-wrap]');
    if (!wrap) return;
    root.dataset.initialized = 'true';
    let renderVersion = 0;

    const selectArea = (area, updateUrl = true) => {
      if (!areas[area]) return;
      root.dataset.activeArea = area;
      root.querySelectorAll('[data-area-title]').forEach((title) => { title.textContent = areas[area].label; });
      root.querySelectorAll('[data-area-list]').forEach((list) => {
        const cards = [...list.querySelectorAll('[data-area-tags]')];
        const matches = cards.filter((card) => area === 'general' || card.dataset.areaTags.includes(`,${area},`));
        const visible = new Set(matches.slice(0, 3));
        cards.forEach((card) => { card.hidden = !visible.has(card); });
        const emptyMessage = list.closest('.hub-body-diagram__group')?.querySelector('[data-area-empty]');
        if (emptyMessage) emptyMessage.hidden = visible.size > 0;
      });
      wrap.querySelectorAll('[data-diagram-area]').forEach((target) => {
        const active = target.dataset.diagramArea === area;
        target.classList.toggle('is-active', active);
        target.setAttribute('aria-pressed', String(active));
      });
      wrap.querySelectorAll('[data-area-marker]').forEach((marker) => {
        marker.classList.toggle('is-active', marker.dataset.areaMarker === area);
      });
      wrap.querySelectorAll('[data-area-label]').forEach((label) => {
        label.classList.toggle('is-active', label.dataset.areaLabel === area);
      });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('area', area);
        window.history.replaceState({}, '', url);

        const ritualsSection = root.querySelector('.hub-body-diagram__rituals');
        ritualsSection?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    };

    const renderDiagram = async () => {
      const version = ++renderVersion;
      const isMobile = mobileQuery.matches;
      const source = isMobile ? root.dataset.diagramMobileSrc : root.dataset.diagramDesktopSrc;
      try {
        const response = await fetch(source, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Diagram asset unavailable');
        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'image/svg+xml');
        const svg = parsed.documentElement;
        if (svg.localName !== 'svg' || parsed.querySelector('parsererror')) throw new Error('Invalid diagram asset');
        const prefix = `hub-body-${Math.random().toString(36).slice(2)}-`;
        const idMap = new Map();
        svg.querySelectorAll('[id]').forEach((element) => {
          const original = element.id;
          element.id = prefix + original;
          idMap.set(original, element.id);
        });
        svg.querySelectorAll('*').forEach((element) => {
          [...element.attributes].forEach((attribute) => {
            let value = attribute.value;
            idMap.forEach((replacement, original) => {
              value = value.replaceAll(`url(#${original})`, `url(#${replacement})`);
              if ((attribute.name === 'href' || attribute.name === 'xlink:href') && value === `#${original}`) value = `#${replacement}`;
            });
            if (value !== attribute.value) element.setAttribute(attribute.name, value);
          });
        });

        const view = isMobile ? 'mobile' : 'desktop';
        const markerCircles = [...svg.querySelectorAll('circle')].filter((circle) => circle.getAttribute('stroke')?.toUpperCase() === '#87184E');
        areaIds.forEach((area) => {
          const areaData = areas[area];
          const [cx, cy] = areaData[view];
          const marker = markerCircles.find((circle) => Math.abs(Number(circle.getAttribute('cx')) - cx) < 0.2 && Math.abs(Number(circle.getAttribute('cy')) - cy) < 0.2);
          if (marker) {
            marker.classList.add('hub-body-diagram__marker');
            marker.dataset.areaMarker = area;
          }
        });

        const labelX = isMobile ? 210 : 450;
        const labelPaths = [...svg.querySelectorAll('path')];
        const overlay = parsed.createElementNS('http://www.w3.org/2000/svg', 'g');
        overlay.setAttribute('class', 'hub-body-diagram__hotspots');
        areaIds.forEach((area) => {
          const areaData = areas[area];
          const point = areaData[view];
          const hitArea = parsed.createElementNS('http://www.w3.org/2000/svg', 'circle');
          hitArea.setAttribute('cx', point[0]);
          hitArea.setAttribute('cy', point[1]);
          hitArea.setAttribute('r', isMobile ? '14' : '18');
          hitArea.setAttribute('class', 'hub-body-diagram__hotspot');
          hitArea.setAttribute('data-diagram-area', area);
          hitArea.setAttribute('role', 'button');
          hitArea.setAttribute('tabindex', '0');
          hitArea.setAttribute('aria-label', areaData.label);
          hitArea.setAttribute('aria-pressed', 'false');
          overlay.appendChild(hitArea);

          const row = isMobile ? areaData.mobileRow : areaData.desktopRow;
          const labelPath = labelPaths.find((path) => {
            const match = path.getAttribute('d')?.match(/^M([\d.]+)\s+([\d.]+)/);
            if (!match) return false;
            const x = Number(match[1]);
            const y = Number(match[2]);
            return x >= labelX && x < (isMobile ? 245 : 510) && Math.abs(y - row) <= 10;
          });
          if (labelPath) {
            labelPath.dataset.areaLabel = area;
            labelPath.classList.add('hub-body-diagram__area-label');
          }

          const labelHitbox = parsed.createElementNS('http://www.w3.org/2000/svg', 'rect');
          labelHitbox.setAttribute('x', isMobile ? '206' : '436');
          labelHitbox.setAttribute('y', String(row - (isMobile ? 12 : 18)));
          labelHitbox.setAttribute('width', isMobile ? '158' : '339');
          labelHitbox.setAttribute('height', isMobile ? '27' : '36');
          labelHitbox.setAttribute('class', 'hub-body-diagram__label-hitbox');
          labelHitbox.setAttribute('data-diagram-area', area);
          labelHitbox.setAttribute('role', 'button');
          labelHitbox.setAttribute('tabindex', '0');
          labelHitbox.setAttribute('aria-label', areaData.label);
          labelHitbox.setAttribute('aria-pressed', 'false');
          overlay.appendChild(labelHitbox);
        });
        svg.appendChild(overlay);
        svg.classList.add('hub-body-diagram__svg');
        svg.setAttribute('role', 'group');
        svg.setAttribute('aria-label', 'Interactive body areas diagram');
        svg.dataset.diagramVariant = view;
        if (version !== renderVersion) return;
        wrap.replaceChildren(document.importNode(svg, true));
        selectArea(root.dataset.activeArea || new URL(window.location.href).searchParams.get('area') || root.dataset.defaultArea || 'liver', false);
      } catch (error) {
        if (version !== renderVersion) return;
        const loading = wrap.querySelector('[data-diagram-loading]');
        if (loading) loading.textContent = 'The body diagram could not be loaded. Choose an area below.';
      }
    };

    root.addEventListener('click', (event) => {
      const areaControl = event.target.closest('[data-diagram-area]');
      if (areaControl && root.contains(areaControl)) selectArea(areaControl.dataset.diagramArea);
    });
    root.addEventListener('keydown', (event) => {
      const control = event.target.closest('[data-diagram-area][role="button"]');
      if (!control || !root.contains(control) || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      selectArea(control.dataset.diagramArea);
    });
    root.addEventListener('focusin', (event) => {
      const control = event.target.closest('[data-diagram-area][role="button"]');
      if (!control || !root.contains(control)) return;
      wrap.querySelectorAll('[data-area-marker]').forEach((marker) => {
        marker.classList.toggle('is-focused', marker.dataset.areaMarker === control.dataset.diagramArea);
      });
    });
    root.addEventListener('focusout', (event) => {
      if (!event.target.closest('[data-diagram-area][role="button"]')) return;
      wrap.querySelectorAll('[data-area-marker].is-focused').forEach((marker) => marker.classList.remove('is-focused'));
    });

    const onBreakpointChange = () => renderDiagram();
    mobileQuery.addEventListener?.('change', onBreakpointChange);
    renderDiagram();
    const requestedArea = new URL(window.location.href).searchParams.get('area');
    selectArea(areas[requestedArea] ? requestedArea : root.dataset.defaultArea || 'liver', false);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-hub-body-diagram]')) init(scope);
    scope.querySelectorAll('[data-hub-body-diagram]').forEach(init);
  };
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
